import React from "react";
import Header from "../Components/GlobalComponent/Header";
import Footer from "../Components/GlobalComponent/Footer";
import ProjectDetailComponent from "../Components/ProjectsComponent/ProjectDetail";

const ProjectDetail = () => {
  return (
    <div>
      <Header />
      <ProjectDetailComponent />
      <Footer />
    </div>
  );
};

export default ProjectDetail; 